import * as actions from "./actionsTypes";

const initialData = {
  loaderDepartamentUser: false,
  departamentUser: null,
  departamentUserFail: null,
  saveLoaderDepartamentUser: false,
  departamentUserFormError: null,
};

export default function DepartamentUserReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_DEPARTAMENTUSER:
      return { ...state, loaderDepartamentUser: action.payload };

    case actions.GET_DEPARTAMENTUSER:
      return { ...state, departamentUser: action.payload };

    case actions.GET_DEPARTAMENTUSER:
      return { ...state, departamentUserFail: action.payload };

    case actions.SAVE_LOADER_DEPARTAMENTUSER:
      return { ...state, saveLoaderDepartamentUser: action.payload };

    case actions.FORM_DEPARTAMENTUSER_FAIL:
      return { ...state, departamentUserFormError: action.payload };

    default:
      return state;
  }
}
